<template>
  <div>
    <div class="video-header">
      <h1>{{ video.actor }} naked</h1>
      <p>in</p>
      <h3>"{{ video.title }}"</h3>
    </div>

    <div class="video-wrap">
      <video
        id="video"
        controls
        disablepictureinpicture
        :poster="'https://malecinema.b-cdn.net/empty_mc5.jpg'"
        preload="none"
        controlslist="nodownload nofullscreen"
      >
        <source
          :src="'https://malecinema.b-cdn.net/empty7.mp4'"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </div>

    <!-- <div class="video-wrap">
      <video
        id="video"
        controls
        disablepictureinpicture
        :poster="video.poster"
        preload="none"
        controlslist="nodownload nofullscreen"
      >
        <source :src="'https:' + video.video" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div> -->

    <Banners />

    <!-- MORE WITH ACTOR -->
    <!-- <div v-if="videoActor.length > 1">
      <h3>&#8595; More with {{ video.actor }} &#8595;</h3>

      <div class="movie-grid">
        <router-link
          v-for="video in videoActor"
          :key="video.id"
          :to="{ name: 'gay-video', params: { id: video.id } }"
          class="grid-box"
        >
          <div class="video-block">
            <img
              :src="'https:' + video.img"
              :alt="video.title"
              class="video-image"
            />
          </div>
          <div class="movie-text">
            <p>{{ video.actor }}</p>
            <p>
              <span>in</span>
            </p>
            <p>"{{ video.title }}"</p>
          </div>
        </router-link>
      </div>
    </div> -->
    <!-- MORE WITH ACTOR END -->

    <!-- MORE WITH TITLE -->
    <!-- <div v-if="videoTitle.length > 1">
      <h3>&#8595; More in {{ video.title }} &#8595;</h3>

      <div class="movie-grid">
        <router-link
          v-for="video in videoTitle"
          :key="video.id"
          :to="{ name: 'gay-video', params: { id: video.id } }"
          class="grid-box"
        >
          <div class="video-block">
            <img
              :src="'https:' + video.img"
              :alt="video.title"
              class="video-image"
            />
          </div>
          <div class="movie-text">
            <p>{{ video.actor }}</p>
            <p>
              <span>in</span>
            </p>
            <p>"{{ video.title }}"</p>
          </div>
        </router-link>
      </div>
    </div> -->
    <!-- MORE WITH TITLER END -->

    <!-- <GayRandom /> -->
  </div>
</template>

<script>
import videosJson from "@/az_final_gay.json";
//import GayRandom from "@/components/GayRandom.vue";
import Banners from "@/views/Banners.vue";
export default {
  props: ["id"],
  components: {
    //GayRandom,
    Banners,
  },
  metaInfo() {
    return {
      title:
        this.video.actor + " Naked Video - Gay Scene From " + this.video.title,
      meta: [
        {
          name: "description",
          content:
            "Free MRMAN gay video of " +
            this.video.actor +
            " naked from movie " +
            this.video.title +
            " - gay sex scenes with nude male celebrities in films!",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.malecinema.com/movies" + this.$route.path,
        },
      ],
    };
  },
  data() {
    return {
      video: [],
      videoActor: [],
      videoTitle: [],
      actor: "",
      title: "",
    };
  },
  methods: {
    getVideo(id) {
      const videosList = JSON.parse(JSON.stringify(videosJson));
      const idNumber = parseInt(id, 10);
      this.video = videosList.find((x) => x.id === idNumber);

      this.actor = this.video.actor;
      this.title = this.video.title;

      // FILTER BY ACTOR

      const videoSearch = videosList.filter((x) => {
        return x.actor === this.actor;
      });

      //console.log(videoSearch);

      this.videoActor = videoSearch.filter((x) => {
        return x.id !== idNumber;
      });

      //console.log(this.videoActor);

      // FILTER BY TITLE MOVIE

      const videoTitleSearch = videosList.filter((x) => {
        return x.title === this.title;
      });

      // console.log(videoTitleSearch);

      this.videoTitle = videoTitleSearch.filter((x) => {
        return x.actor !== this.actor;
      });

      // console.log(this.videoTitle);

      window.scrollTo(0, 0);
      //console.log("getVideo " + id);
    },
    tracking(id) {
      this.$ga.page("/movies/gay/video/" + id);
      //console.log(id);
      //console.log("movie " + this.$route.params.id);
    },
    reloadVid() {
      document.getElementById("video").load();
    },
  },
  created() {
    this.getVideo(this.id);
    this.tracking(this.id);
  },
  watch: {
    $route() {
      this.getVideo(this.id);
      this.reloadVid();
      this.tracking(this.id);
    },
  },
};
</script>